<div class="spinner-overlay">
    <mat-progress-spinner [diameter]="50" mode="indeterminate"></mat-progress-spinner>
</div>